import React from 'react';
import './InsightsPage.css';

const InsightsPage = () => {
  const articles = [
    { title: 'The Rise of Agentic AI', category: 'Trends', date: 'March 14, 2026' },
    { title: 'Optimizing Supply Chains with RL', category: 'Case Study', date: 'March 10, 2026' },
    { title: 'Ethical Implications of Gen AI', category: 'Philosophy', date: 'March 5, 2026' },
    { title: 'Edge Computing in 2026', category: 'Technology', date: 'Feb 28, 2026' }
  ];

  return (
    <div className="insights-container">
      <section className="insights-hero">
        <div className="hero-content">
          <h1>Knowledge <span className="highlight">Lab</span></h1>
          <p>Exploring the latest frontiers in Artificial Intelligence and Machine Learning.</p>
        </div>
      </section>

      <section className="articles-grid-section">
        <div className="articles-grid">
          {articles.map((art, i) => (
            <div key={i} className="article-card">
              <div className="art-category">{art.category}</div>
              <h3>{art.title}</h3>
              <div className="art-footer">
                <span>{art.date}</span>
                <button className="read-more">Read Entry →</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default InsightsPage;
